var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.viewTag==1)?_c('AppTag'):_vm._e(),_c('el-container',{attrs:{"direction":"vertical"}},[_c('el-main',[(_vm.isRefash)?_c('router-view'):_vm._e()],1),(_vm.viewFooter==1)?_c('el-footer',{attrs:{"height":"25px"}},[_c('div',[_vm._v(_vm._s(_vm.title)+" ")])]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }